var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
import { useSafeRunMutation } from 'utils/mutations';
// TEAM_UPDATE_DELIVERABLES
export var mutation = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation TeamUpdateDeliverables($add_ids: [ID!], $team_id: ID!, $remove_ids: [ID!]) {\n    teamUpdateDeliverables(\n      add_ids: $add_ids\n      team_id: $team_id\n      remove_ids: $remove_ids\n    ) {\n      added {\n        id\n      }\n    }\n  }\n"], ["\n  mutation TeamUpdateDeliverables($add_ids: [ID!], $team_id: ID!, $remove_ids: [ID!]) {\n    teamUpdateDeliverables(\n      add_ids: $add_ids\n      team_id: $team_id\n      remove_ids: $remove_ids\n    ) {\n      added {\n        id\n      }\n    }\n  }\n"])));
export default function useTeamUpdateDeliverablesMutation() {
    var _a = useSafeRunMutation({
        mutation: mutation,
        responsePath: 'teamUpdateDeliverables',
        successMessage: 'Team deliverables updated'
    }), onMutate = _a.onMutate, loading = _a.loading;
    return { onMutate: onMutate, loading: loading };
}
var templateObject_1;
